import App from '../../components/App/Desktop/App';

export default App;
